import { useQuery } from "@tanstack/react-query";
import {
  getSurveyResponses,
  getSurveyResponseDetails,
  getSurveyResponseStats,
} from "api/bSurveysApi";

/**
 * Hook for fetching survey responses with filtering and pagination
 */
export function useSurveyResponses(organisationId, options = {}) {
  const { templateId, search, limit = 100, offset = 0, enabled = true } = options;

  return useQuery({
    queryKey: ["surveyResponses", organisationId, templateId, search, limit, offset],
    queryFn: () => 
      getSurveyResponses(organisationId, { templateId, search, limit, offset })
        .then((res) => res.data),
    enabled: !!organisationId && enabled,
  });
}

/**
 * Hook for fetching a single survey response with all answers
 */
export function useSurveyResponseDetails(responseId) {
  return useQuery({
    queryKey: ["surveyResponse", responseId],
    queryFn: () => getSurveyResponseDetails(responseId).then((res) => res.data),
    enabled: !!responseId,
  });
}

/**
 * Hook for fetching aggregated survey response statistics
 */
export function useSurveyResponseStats(organisationId, templateId = null) {
  return useQuery({
    queryKey: ["surveyResponseStats", organisationId, templateId],
    queryFn: () => getSurveyResponseStats(organisationId, templateId).then((res) => res.data),
    enabled: !!organisationId,
  });
}
